import { CartAddEvent } from '@theme/events';

class VariantQuickAdd extends HTMLElement {
  constructor() {
    super();
    this.pending = false;
  }

  connectedCallback() {
    this.variantId = Number(this.dataset.variantId);
    this.productId = this.dataset.productId;
    this.addBtn = this.querySelector('[data-action="add"]');
    this.addBtn?.addEventListener('click', this.onAdd.bind(this));
  }

  setPending(on) {
    this.pending = on;
    if (!this.addBtn) return;
    if (on) {
      this.addBtn.setAttribute('disabled', '');
      this.addBtn.setAttribute('aria-busy', 'true');
    } else {
      this.addBtn.removeAttribute('disabled');
      this.addBtn.removeAttribute('aria-busy');
    }
  }

  async onAdd(event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.pending || !this.variantId) return;
    this.setPending(true);
    try {
      const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
        .map((el) => el.dataset.sectionId)
        .filter(Boolean);

      const body = { id: this.variantId, quantity: 1 };
      if (sectionIds.length) body.sections = sectionIds.join(',');

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });

      if (!res.ok) throw new Error(`add failed: ${res.status}`);
      const data = await res.json();

      this.dispatchEvent(
        new CartAddEvent(data, this.id || 'variant-quick-add', {
          source: 'variant-quick-add',
          variantId: String(this.variantId),
          productId: this.productId,
          sections: data.sections,
        })
      );
    } catch (err) {
      console.error('variant-quick-add: failed to add', err);
    } finally {
      this.setPending(false);
    }
  }
}

if (!customElements.get('variant-quick-add')) {
  customElements.define('variant-quick-add', VariantQuickAdd);
}
